import React from 'react';
import cn from 'classnames';
import KeuneIconBlack from 'components/shared/keune-icon-black';
import KeuneIconWhite from 'components/shared/keune-icon-white';
import styles from './searchFilter.module.scss';

const SearchFilter = ({ content, filtersList, activeFilters, setActiveFilters }) => {
  const capitalizedContent = content.toUpperCase();
  const capitalizedAllFilter = filtersList[0]?.toUpperCase();
  const capitalizedAmbasadorFilter = filtersList[1]?.toUpperCase();
  const capitalizedKeuneFilter = filtersList[2]?.toUpperCase();

  const isActive = activeFilters.includes(capitalizedContent);

  const handleClick = c => {
    if (c === capitalizedAllFilter) {
      setActiveFilters([capitalizedAllFilter]);
      return;
    }

    if (isActive) {
      const newFilters = activeFilters.filter(f => f !== c);
      if (!newFilters.length) {
        newFilters.push(capitalizedAllFilter);
      }

      setActiveFilters(newFilters);
    } else {
      setActiveFilters([...activeFilters, c].filter(f => f !== capitalizedAllFilter));
    }
  };

  return (
    <button
      type="button"
      className={cn(
        styles.filter,
        capitalizedContent === capitalizedAllFilter && styles.allSalons,
        capitalizedContent === capitalizedAmbasadorFilter && styles.ambassador,
        isActive && styles.active
      )}
      onClick={() => handleClick(content)}
    >
      {(capitalizedContent === capitalizedAmbasadorFilter ||
        capitalizedContent === capitalizedKeuneFilter) && (
        <>
          {isActive ? (
            <KeuneIconWhite className={styles.logo} width="1.1rem" height="1rem" />
          ) : (
            <KeuneIconBlack className={styles.logo} width="1.1rem" height="1rem" />
          )}
        </>
      )}
      {content}
    </button>
  );
};

export default SearchFilter;
